import { AgrEnvironment } from '@next/core-lib/environment';

export class RoughagePlusEnvironment extends AgrEnvironment {
  declare LEAD_SIGNUP_POLICY: string;
  declare EMPLOYEE_SIGNIN_POLICY: string;
  declare ENABLE_SILAGE_SOIL: boolean;
  declare ENABLE_SOIL: boolean;
  declare ENABLE_TELEMETRY: boolean;
}
